(() => {
  const start = () => {
    document.querySelectorAll('[data-ss-search-field]').forEach(field => {
      if (field.dataset.ssSearchReady) return;
      field.dataset.ssSearchReady = 'true';
      const input = field.querySelector('input[type=search]'), form = input.form;
      const results = field.querySelector('[data-ss-search-results]'), all = field.querySelector('[data-ss-search-all]');
      const status = field.querySelector('[role=status]'), initialStatus = status.textContent, clear = field.querySelector('[type=reset]');
      const cache = new Map();
      let timer, controller, generation = 0, selected = -1, composing = false;
      const options = () => [...results.querySelectorAll('[role=option]')];
      const resetSelection = () => { selected = -1; input.removeAttribute('aria-activedescendant'); options().forEach(option => option.setAttribute('aria-selected','false')); };
      const cancel = () => { clearTimeout(timer); controller?.abort(); ++generation; };
      const hide = () => { cancel(); results.hidden = true; results.replaceChildren(); all.hidden = true; input.setAttribute('aria-expanded','false'); input.removeAttribute('aria-busy'); resetSelection(); status.textContent = initialStatus; };
      const render = html => {
        const parsed = new DOMParser().parseFromString(html,'text/html').querySelector('[data-ss-suggestions]');
        if (!parsed) throw new Error('Missing suggestions');
        results.replaceChildren(...parsed.childNodes);
        options().forEach((option,index) => { option.id = results.id + '-' + index; });
        results.hidden = false; input.setAttribute('aria-expanded',String(options().length > 0)); resetSelection();
        status.textContent = field.dataset.count.replace('[count]', String(options().length));
      };
      const update = () => {
        if (composing) return;
        cancel(); input.removeAttribute('aria-busy'); resetSelection();
        const term = input.value.trim(); clear.hidden = !input.value;
        const href = new URL(form.action,location.href); href.searchParams.set('q',term); href.searchParams.set('type','product'); href.searchParams.set('options[prefix]','last');
        all.href = href.pathname + href.search; all.hidden = term.length < 2;
        if (term.length < 2) { hide(); return; }
        results.hidden = true; results.replaceChildren(); input.setAttribute('aria-expanded','false'); status.textContent = field.dataset.loading;
        const version = generation;
        timer = setTimeout(async () => {
          const key = term.toLocaleLowerCase();
          if (cache.has(key)) { render(cache.get(key)); return; }
          controller = new AbortController(); const request = controller;
          const timeout = setTimeout(() => request.abort(),8000);
          input.setAttribute('aria-busy','true');
          try {
            const endpoint = new URL(field.dataset.endpoint,location.origin);
            if (endpoint.origin !== location.origin) throw new Error('Invalid endpoint');
            endpoint.searchParams.set('q',term); endpoint.searchParams.set('section_id','ss-search-results');
            endpoint.searchParams.set('resources[type]','product,collection,query'); endpoint.searchParams.set('resources[limit]','6'); endpoint.searchParams.set('resources[limit_scope]','each');
            const preview = new URL(location.href).searchParams.get('preview_theme_id'); if(preview) endpoint.searchParams.set('preview_theme_id',preview);
            const response = await fetch(endpoint.pathname + endpoint.search,{signal:request.signal});
            if (!response.ok) throw new Error('Search unavailable');
            const html = await response.text(); if (version !== generation) return;
            render(html); cache.set(key,html); if(cache.size > 20) cache.delete(cache.keys().next().value);
          } catch(error) {
            if(version !== generation) return;
            results.hidden = true; input.setAttribute('aria-expanded','false'); status.textContent = field.dataset.error;
          } finally { clearTimeout(timeout); if(version === generation) input.removeAttribute('aria-busy'); }
        },160);
      };
      input.addEventListener('input',update);
      input.addEventListener('compositionstart',()=>{composing=true;});
      input.addEventListener('compositionend',()=>{composing=false;update();});
      form.addEventListener('reset',event=>{event.preventDefault();input.value='';clear.hidden=true;hide();input.focus();});
      form.addEventListener('submit',event=>{if(!input.value.trim())event.preventDefault();else cancel();});
      input.addEventListener('keydown',event=>{
        const nodes = options();
        if(event.key === 'Escape' && !results.hidden) { event.preventDefault();event.stopPropagation();hide();return; }
        if(event.key === 'Enter' && selected >= 0 && nodes[selected]) { event.preventDefault();nodes[selected].querySelector('a')?.click();return; }
        if(!['ArrowDown','ArrowUp'].includes(event.key) || !nodes.length) return;
        event.preventDefault(); selected = (selected + (event.key === 'ArrowDown' ? 1 : -1) + nodes.length) % nodes.length;
        nodes.forEach((node,index)=>node.setAttribute('aria-selected',String(index===selected)));
        input.setAttribute('aria-activedescendant',nodes[selected].id); nodes[selected].scrollIntoView({block:'nearest'});
      });
      const owner = field.closest('details'); owner?.addEventListener('toggle',()=>{if(!owner.open)hide();});
    });
  };
  if(document.readyState === 'loading') { const ready = () => { if(document.readyState === 'loading')return;document.removeEventListener('readystatechange',ready);start(); };document.addEventListener('readystatechange',ready); } else start();
})();
